/**
 * @generated SignedSource<<d1422f887006bd0da34c0cdb3927c526>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationEndDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationStartDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patternId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routeId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patternId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  (v11/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headsign",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRoutes_RouteAlertsContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RouteAlertsContainerFragment_route"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cancelationEndDate",
                "variableName": "cancelationEndDate"
              },
              {
                "kind": "Variable",
                "name": "cancelationStartDate",
                "variableName": "cancelationStartDate"
              }
            ],
            "kind": "FragmentSpread",
            "name": "RouteAlertsContainerFragment_pattern"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "routeRoutes_RouteAlertsContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stop",
            "kind": "LinkedField",
            "name": "stops",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "ROUTE",
                  "STOPS_ON_PATTERN"
                ]
              }
            ],
            "concreteType": "Alert",
            "kind": "LinkedField",
            "name": "alerts",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertDescriptionText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertHash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertHeaderText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertEffect",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertSeverityLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveEndDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveStartDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "entities",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v8/*: any*/),
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "type": "Route",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vehicleMode",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "type": "Stop",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "alerts(types:[\"ROUTE\",\"STOPS_ON_PATTERN\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "items": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "end",
                        "variableName": "cancelationEndDate"
                      },
                      {
                        "kind": "Variable",
                        "name": "start",
                        "variableName": "cancelationStartDate"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "runningTimeRanges.0"
                  }
                ],
                "kind": "ListValue",
                "name": "runningTimeRanges"
              }
            ],
            "concreteType": "TripOnServiceDate",
            "kind": "LinkedField",
            "name": "canceledTrips",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "trip",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tripHeadsign",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimes",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "realtimeState",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledArrival",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledDeparture",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "serviceDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stop",
                        "kind": "LinkedField",
                        "name": "stop",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83aa7d3873e1c994a2a1c40e524375a9",
    "id": null,
    "metadata": {},
    "name": "routeRoutes_RouteAlertsContainer_Query",
    "operationKind": "query",
    "text": "query routeRoutes_RouteAlertsContainer_Query(\n  $routeId: String!\n  $patternId: String!\n  $cancelationStartDate: OffsetDateTime!\n  $cancelationEndDate: OffsetDateTime!\n) {\n  route(id: $routeId) {\n    ...RouteAlertsContainerFragment_route\n    id\n  }\n  pattern(id: $patternId) {\n    ...RouteAlertsContainerFragment_pattern_4gwf7I\n    id\n  }\n}\n\nfragment RouteAlertsContainerFragment_pattern_4gwf7I on Pattern {\n  stops {\n    name\n    id\n  }\n  code\n  headsign\n  alerts(types: [ROUTE, STOPS_ON_PATTERN]) {\n    id\n    alertDescriptionText\n    alertHash\n    alertHeaderText\n    alertEffect\n    alertSeverityLevel\n    alertUrl\n    effectiveEndDate\n    effectiveStartDate\n    entities {\n      __typename\n      ... on Route {\n        color\n        type\n        mode\n        shortName\n        gtfsId\n      }\n      ... on Stop {\n        name\n        code\n        locationType\n        vehicleMode\n        gtfsId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  canceledTrips(runningTimeRanges: [{start: $cancelationStartDate, end: $cancelationEndDate}]) {\n    serviceDate\n    trip {\n      tripHeadsign\n      stoptimes {\n        headsign\n        realtimeState\n        scheduledArrival\n        scheduledDeparture\n        serviceDay\n        stop {\n          name\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment RouteAlertsContainerFragment_route on Route {\n  color\n  mode\n  type\n  shortName\n  gtfsId\n}\n"
  }
};
})();

node.hash = "718270c36e0fafba2c60570032ef560b";

export default node;
